import { useSessionStore } from "@/modules/auth/store/useSessionStore";
import { Navigate, Outlet } from "react-router-dom";
import { ROUTES } from "../constants/routes";
import Sidebar from "../components/Sidebar";

const MainLayout = () => {
  const { session } = useSessionStore();

  if (!session) return <Navigate to={ROUTES.AUTH.LOGIN} />;

  return (
    <div className="flex h-screen w-screen overflow-hidden">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden bg-[#F5F5F5]">
        <div className="flex-1 overflow-auto p-6">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
